import { CheckCircle2Icon, ZapIcon, ShieldCheckIcon, type LucideIcon } from 'lucide-react';

export interface PricingRow {
  content: string;
  value: string;
}

export const pricingRows: PricingRow[] = [
  { content: 'Colección Completa (11 Tomos)', value: '197€' },
  { content: 'Los 4 Bonos Estratégicos', value: '56,60€' },
  { content: 'Acceso de por vida', value: '∞' }
];

export interface PricingTrustItem {
  icon: LucideIcon;
  label: string;
}

export const pricingTrustItems: PricingTrustItem[] = [
  { icon: CheckCircle2Icon, label: 'Pago único' },
  { icon: ZapIcon, label: 'Acceso inmediato' },
  { icon: ShieldCheckIcon, label: 'Garantía 7 días' }
];
